import React from 'react'
import RolesDataItem from "./RolesDataItem"

function RolesDataBody(props) {
    const {listRoles} = props

    return (
        <tbody className="TableBody">
        {
            !!listRoles && listRoles.length > 0 ? listRoles.map((item, index) => (
                <RolesDataItem key={index} index={index} item={item}/>
            )) : <tr className="NoRecord">
                <td colSpan={7}>Không có bản ghi nào</td>
            </tr>
        }
        </tbody>
    )
}

export default RolesDataBody
